module.exports = __webpack_public_path__ + "img/symbol_4.66b84cd2.png";